export default __webpack_public_path__ + "media/samples/Next_Live_Stream-ed3e46eb.jpeg";